import { render } from "./working-with-artisan.vue?vue&type=template&id=573199da&scoped=true"
import script from "./working-with-artisan.vue?vue&type=script&lang=js"
export * from "./working-with-artisan.vue?vue&type=script&lang=js"

import "./working-with-artisan.vue?vue&type=style&index=0&id=573199da&lang=css"
import "./working-with-artisan.vue?vue&type=style&index=1&id=573199da&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573199da"]])

export default __exports__